<template>
    <div class="alert" v-bind:class="{ 'is-active' : text, 'is-error' : type == 'error', 'is-success' : type == 'success' }">
        <span class="jam" v-bind:class="{ 'jam-shield-close' : type == 'error', 'jam-shield-check' : type == 'success' }"></span>
        <span class="alert__text">{{ text }}</span>

        <a class="alert__close" v-on:click="closeAlert">&times;</a>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        created: function () {
            // attach event listeners
            eventBus.$on('show-alert', this.showAlert);
        },
        data: function () {
            return {
                alertTimeout: null,
                text: null,
                timeout: 5000,
                type: null
            }
        },
        methods: {
            closeAlert: function () {
                clearTimeout(this.alertTimeout);

                this.text = null;
                this.type = null;
            },
            showAlert: function (type, text) {
                this.text = text;
                this.type = type;

                this.alertTimeout = setTimeout(this.closeAlert, this.timeout);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/elements/Alert.vue